<template>
  <VDialogV3
    id="transport-order-requisites-dialog"
    position="right"
    :entity="localTransportOrder"
    @submit="save"
    width="600px"
  >
    <!-- Тип ЗТК -->
    <section>
      <header>Тип заявки</header>

      <VSelectV2
        v-model="localTransportOrderType"
        label="Тип ЗТК"
        required
        :disabled="localTransportOrder.isExisting === true"
        disabled-reasons="Тип задаётся только при создании ЗТК"
        :data="TransportOrder.types"
      />
    </section>

    <template v-if="showSender === true">
      <!-- Участники — отправитель -->
      <section>
        <header>Отправитель</header>

        <template v-if="localTransportOrder.isReturn === true">
          <VSelectV2
            v-model="localTransportOrder.sender"
            label="Отправитель"
            :data="({ pattern }) => PartnersService.searchBuyers(pattern)"
          />
        </template>
        <template v-else>
          <VSelectV2
            v-model="localTransportOrder.sender"
            label="Отправитель"
            :data="({ pattern }) => PartnersService.searchSellers(pattern)"
          />
        </template>

        <VSelectV2
          v-model="localTransportOrder.senderCompany"
          label="Юр лицо отправителя"
          :data="senderCompanySource"
        />

        <VSelectV2
          v-if="showSenderStore === true"
          v-model="localTransportOrder.senderStore"
          label="Склад отправителя"
          :data="senderStoreSource"
        />
        <!--              :required="localTransportOrder.isOrderPositionPickup || localTransportOrder.isReturn || localTransportOrder.isInternal"-->

      </section>
    </template>

    <!-- Получатель -->
    <section>
      <header>Получатель</header>

      <template v-if="localTransportOrder.isReturn === true">
        <VSelectV2
          v-model="localTransportOrder.receiver"
          label="Получатель"
          required
          :data="({pattern}) => PartnersService.searchSellers(pattern)"
        />
      </template>
      <template v-else>
        <VSelectV2
          v-model="localTransportOrder.receiver"
          label="Получатель"
          required
          :data="({pattern}) => PartnersService.searchBuyers(pattern)"
        />
      </template>

      <VSelectV2
        required
        v-model="localTransportOrder.receiverCompany"
        label="Юр лицо получателя"
        :data="receiverCompanySource"
      />

      <VSelectV2
        v-model="localTransportOrder.receiverStore"
        label="Склад получателя"
        :required="localTransportOrder.isService === false"
        :data="receiverStoreSource"
      />

      <VSelectV2
        v-model="localTransportOrder.responsibleReceiver"
        required
        label="Ответственный от получателя"
        placeholder="Введите ФИО ответственного"
        :data="responsibleReceiverSource"
      />
    </section>

    <!-- Основное -->
    <section>
      <header>Основное</header>

      <VDateInput
        ref="pickupDatePlannedInput"
        label="Плановая дата забора"
        layout="vertical"
        required
        :value="localTransportOrder.pickupDatePlanned"
        @input="setPickupDatePlanned"
        :validate-method="value => localTransportOrder.validatePickupDatePlanned(value)"
      />

      <VDateInput
        ref="arrivalDatePlannedInput"
        v-model="localTransportOrder.arrivalDatePlanned"
        label="Плановая дата получения"
        layout="vertical"
        required
        :validate-method="value => localTransportOrder.validateArrivalDatePlanned(value)"
      />

      <VSwitch
        ref="isConfirmed"
        v-model="localTransportOrder.isConfirmed"
        checked-label="Утверждена"
        unchecked-label="Не утверждена"
        theme="slider"
      />

      <VTextarea
        v-model="localTransportOrder.note"
        label="Примечание"
        layout="vertical"
      >
        <template #helper-text>
          Будет отражено в портальной задаче и в заявке Excel
        </template>
      </VTextarea>
    </section>

    <section class="declared-cost-form">
      <div>
        Объявленная ценность:
        {{ localTransportOrder.declaredCost?.format(transportOrder.declaredCostCurrencyCode) || '--' }}
      </div>
    </section>

    <!-- Уведомления и портальная задача — только для single_sender, только создание -->
    <template v-if="localTransportOrder.isExisting === false && localTransportOrder.isSingleSender === true">
      <section class="send-email">
        <VCheckbox v-model="isSendToEmail" @input="onToggleSendEmail">
          Отправить уведомление на почту
        </VCheckbox>
      </section>

      <section v-if="isSendToEmail === true">
        <SWMailingList
          :receivers="localReceiversMail"
          @update="updateReceivers"
        />
      </section>

      <template v-if="transportOrder.receiver.id === $core.sibWellPartner.id">
        <section>
          <VCheckbox
            v-model="isCreateSWPortalTask"
            :disabled="$core.utils.isNullOrUndefined(localTransportOrder.pickupDatePlanned) === true"
            @input="onTogglePortalTask"
          >
            Создать задачу на портале
            <template v-if="$core.utils.isNullOrUndefined(localTransportOrder.pickupDatePlanned) === true" #helper-text>
              Чтобы создать задачу, нужно заполнить плановую дату забора груза
            </template>
          </VCheckbox>
        </section>

        <section v-if="$core.utils.isNullOrUndefined(localSWPortalTask) === false && isCreateSWPortalTask === true">
          <SWPortalTaskForm
            hide-header
            :sw-portal-task="localSWPortalTask"
          />
        </section>
      </template>
    </template>

    <!-- Портальная задача — только для первого покупателя, только для single_sender, только редактирование -->
    <template v-if="
       localTransportOrder.isExisting === true
       && localTransportOrder.isSingleSender === true
       && transportOrder?.receiver?.id === $core.sibWellPartner.id
    ">
      <section>
        <header>Задача на корпоративном портале</header>
        <VLink
          v-if="$core.utils.isNullOrUndefined(transportOrder.swPortalTask) === false"
          :href="'https://cp.siberianhealth.com/task3/view.php?id=' + transportOrder.swPortalTask.id"
          target="_blank"
        >
          Задача №{{ transportOrder.swPortalTask.id }}
          <template v-if="$core.utils.isNullOrUndefined(transportOrder.swPortalTask.createdAt) === false">
            от {{ $core.utils.date.format(transportOrder.swPortalTask.createdAt) }}
          </template>
        </VLink>
        <template
          v-else-if="transportOrder.isFinished === false && $core.currentPartner?.isLSZ === true">
          Задачи нет, вы можете её
          <VLink material="add" @click="openSWPortalTaskDialog">создать</VLink>
        </template>
        <template v-else>Задачи нет</template>
      </section>

      <section class="assembly-data">
        <header>Отгрузочные документы на сборочные листы</header>
        <template v-if="assemblies.length > 0">
          <article
            v-for="(assembly, index) in assemblies"
            :key="assembly.id + '_' + index"
          >
            <div class="title">
              Сборочный лист №{{ assembly.id }} от {{ $core.utils.date.format(assembly.createdAt) }}
            </div>
            Отгружен:
            <template v-if="assembly.isShipped === true">
                <span class="description">
                  Да, {{ assembly.isShippedEntirely === true ? 'полностью' : 'частично' }}
                </span>
            </template>
            <template v-else>Нет</template>
          </article>
        </template>
        <template v-else>Отсутствуют</template>
      </section>
    </template>


    <hr>

    <!-- Транспорт: компания, водитель и трек-номер одним блоком. ТС поднято наверх стилями, см. .scss -->
    <section class="transport">
      <header>Транспорт</header>

      <VSelectV2
        ref="delivererSelect"
        label="Транспортная компания"
        v-model="localTransportOrder.deliverer"
        :required="localTransportOrder.isService"
        :data="({pattern}) =>  PartnersService.getList({ pattern, types: ['deliverer'] })"
      >

        <template #helper-text>
          <span>Если нужной транспортной компании нет, вы можете её </span>
          <VLink @click="showDelivererCreateDialog">создать</VLink>
        </template>

      </VSelectV2>

      <!-- Водитель, госномер и тип владения — скрыты для single_sender. Транспорт и госномер — реквизиты ЗТК, водитель лишь подставляет свои в пустые поля -->
      <DriverForm
        v-if="showVehicle === true"
        :transport-order="localTransportOrder"
        :show-headers="false"
      />

      <VInput
        ref="trackingNumberInput"
        v-model="localTransportOrder.trackingNumber"
        label="Трек-номер"
        layout="vertical"
        :max-length="100"
      />
    </section>

    <!-- Склад перевозчика — скрыт для internal, service, single_sender и для Намангана -->
    <template v-if="showDelivererStore === true">
      <section>
        <VSelectV2
          label="Склад перевозчика"
          v-model="localTransportOrder.delivererStore"
          :data="delivererStoreSource"
        />
      </section>

    </template>

    <!-- Дедлайн и таможня: дедлайн, статус и комментарий -->
    <section>
      <header>Дедлайн и таможня</header>

      <!-- Дедлайн виден всегда, как в шапке карточки; у обычной ЗТК не заполняется -->
      <VDateInput
        v-model="localTransportOrder.deadline"
        label="Дедлайн"
        layout="vertical"
        clearable
        :disabled="localTransportOrder.isSingleSender === true"
        :disabled-reasons="localTransportOrder.isSingleSender === true ? 'У обычной ЗТК дедлайн не заполняется' : null"
      />

      <!-- Таможенный статус и комментарий скрыты для single_sender — обычная ЗТК их не заполняет -->
      <template v-if="localTransportOrder.isSingleSender === false">
        <VSelectV2
          v-model="localTransportOrder.borderStatus"
          label="Таможенный статус"
          layout="vertical"
          :data="TransportOrder.borderStatuses"
        />

        <VTextarea
          v-model="localTransportOrder.comment"
          label="Комментарий"
          layout="vertical"
        />
      </template>
    </section>

    <template v-if="showTransportCost === true">
      <!-- Стоимость перевозки -->
      <section>
        <header>Стоимость перевозки</header>
        <VInputNumberRusV2
          v-model="localTransportOrder.transportCostPlanned"
          :type="Sum"
          label="Плановая стоимость"
          layout="vertical"
        />
      </section>
    </template>

    <hr>

    <!-- Простои транспорта — скрыты для single_sender -->
    <section class="grid-block">
      <header>
        Простои транспорта
        <VLink
          :disabled="localTransportOrder.isExisting === false"
          @click="addDowntime"
          material="add"
        >
          Добавить простой
        </VLink>
      </header>

      <div class="content">
        <VDataGridV2
          :data="localTransportOrder.downtimes"
          :context-menu="TransportDowntimesService.contextMenu"
          layout="fill"
          @row:dblclick="row => editDowntime(row, localTransportOrder.downtimes.indexOf(row))"
          @context-menu-item:done="reloadDowntimes"
        >
          <VDataGridColumnV2
            id="reason"
            label="Причина"
            content-class="ellipsis"
            width="300px"
          >
            <template #default="{ row }">
              <div
                class="ellipsis"
                :title="row.reason"
              >
                {{ row.reason || '--' }}
              </div>
              <div class="description">
                {{ row.period?.toString() ?? '--' }}
              </div>
            </template>
          </VDataGridColumnV2>

          <!--          <VDataGridColumnV2-->
          <!--            id="period"-->
          <!--            label="Период"-->
          <!--            width="150px"-->
          <!--          >-->
          <!--            <template #default="{ row }">-->
          <!--              {{ row.period?.toString() ?? '&#45;&#45;' }}-->
          <!--            </template>-->
          <!--          </VDataGridColumnV2>-->

          <VDataGridColumnV2
            id="cost"
            label="Стоимость"
            content-align="right"
            width="100px"
          >
            <template #default="{ row }">
              {{ row.cost.format(row.currencyCode) }}
            </template>
          </VDataGridColumnV2>
        </VDataGridV2>
      </div>
    </section>

    <!-- Факт доставки -->
    <section>
      <header>Факт доставки</header>
      <VDateInput
        ref="pickupDateActualInput"
        v-model="localTransportOrder.pickupDateActual"
        label="Фактическая дата забора"
        layout="vertical"
        clearable
      />

      <VDateInput
        ref="arrivalDateActualInput"
        v-model="localTransportOrder.arrivalDateActual"
        label="Фактическая дата прибытия"
        layout="vertical"
        clearable
        :validate-method="value => localTransportOrder.validateArrivalDateActual(value)"
      />

      <VInputNumberRusV2
        v-if="showTransportCost === true"
        v-model="localTransportOrder.transportCostActual"
        :type="Sum"
        label="Фактическая стоимость"
        layout="vertical"
      />
    </section>

    <!-- Своя оценка выбранного водителя — сохраняется вместе с ЗТК. Без водителя блок задизейблен -->
    <template v-if="showVehicle === true">
      <DriverUserFeedback
        :feedback="localTransportOrder.driver?.feedback ?? null"
      />
    </template>
  </VDialogV3>
</template>

<style lang="scss" src="./TransportOrderRequisitesDialog.scss"/>

<script lang="ts">

import Core                      from '@/core/Core';
import SWPortalTask              from '@/domains/SWPortalTask/SWPortalTask';
import PersonsService            from '@/domains/Persons/PersonsService';
import PartnersService           from '@/domains/Partners/PartnersService';
import TransportOrder            from '@/domains/TransportOrders/TransportOrder';
import TransportDowntime         from '@/domains/TransportDowntime/TransportDowntime';
import Driver                    from '@/domains/Drivers/Driver';
import DriverFeedback            from '@/domains/Drivers/DriverFeedback';
import StoresService             from '@/domains/Stores/StoresService';
import CompaniesService          from '@/domains/Companies/CompaniesService';
import TransportDowntimesService from "@/domains/TransportDowntime/TransportDowntimesService";
import Assembly                  from '@/domains/Assemblies/Assembly';
import Sum                       from '@/core/types/Sum'
import Partner                   from "@/domains/Partners/Partner";
import SWPortalTasksService      from "@/domains/SWPortalTask/SWPortalTasksService";

import SWPortalTaskForm          from '@/domains/SWPortalTask/components/SWPortalTaskCreateDialog/SWPortalTaskForm';
import SWMailingList             from "@/domains/TransportOrders/components/SWMailingListCreateDialog/SWMailingList.vue";
import DriverForm                from '@/domains/Drivers/components/DriverCard/DriverForm.vue';
import DriverUserFeedback        from '@/domains/Drivers/components/DriverCard/DriverUserFeedback.vue';

export default defineComponent({
  name: 'TransportOrderRequisitesDialog',

  components: {
    SWPortalTaskForm,
    SWMailingList,
    DriverForm,
    DriverUserFeedback,
  },

  props: {
    transportOrder: {
      type: Object as PropType<TransportOrder>,
      required: true,
    },
    swPortalTask: {
      type: Object,
      default: null,
    },
    receivers: {
      type: Array,
      default: null,
    },
  },


  setup() {
    return {
      PartnersService,
      TransportOrder,
      Sum,
      SWPortalTasksService,
      TransportDowntimesService,
    }
  },

  data() {
    const localTransportOrder = this.$core.utils.cloneDeepWithReference(this.transportOrder, ['positions']);
    localTransportOrder.calculateDeclaredCost();

    /**
     * Правило прелоада зависимых источников документа:
     * - новый — preloadOnMount: опции готовы до первого клика,
     *   контрагентские подгрузятся сами при выборе партнёра;
     * - существующий — preloadOnFocus: шанс, что реквизиты станут
     *   менять, низок — впустую не грузим.
     */
    const isNewDocument = this.transportOrder.isExisting === false;

    const senderCompanySource = this.$core.loader.select<TransportOrder>(({sender}) =>
      CompaniesService.getList({ partnerId: sender.id })
    )
      .dependsOn({sender: () => this.localTransportOrder.sender})
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const senderStoreSource = this.$core.loader.select<TransportOrder>(({sender}) =>
      StoresService.getList({ partnerId: sender.id })
    )
      .dependsOn({
        sender:        () => this.localTransportOrder.sender,
        senderCompany: () => this.localTransportOrder.senderCompany,
      })
      .default((options) => this.localTransportOrder.findDefaultSenderStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    /** Перевалочный пункт — наш склад, а не склад перевозчика, поэтому от deliverer не зависит */
    const delivererStoreSource = this.$core.loader.select<TransportOrder>(() =>
      StoresService.getList({ partnerId: this.$core.sibWellPartner.id })
    )
      .default((options) => this.localTransportOrder.findDefaultDelivererStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const receiverCompanySource = this.$core.loader.select<TransportOrder>(({receiver}) =>
      CompaniesService.getList({ partnerId: receiver.id })
    )
      .dependsOn({receiver: () => this.localTransportOrder.receiver})
      .default((options) => this.localTransportOrder.findDefaultReceiverCompany(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    const receiverStoreSource = this.$core.loader.select<TransportOrder>(({receiver}) =>
      StoresService.getList({ partnerId: receiver.id })
    )
      .dependsOn({
        receiver:        () => this.localTransportOrder.receiver,
        receiverCompany: () => this.localTransportOrder.receiverCompany,
      })
      .default((options) => this.localTransportOrder.findDefaultReceiverStore(options))
      .preloadOnMount(isNewDocument === true)
      .preloadOnFocus(isNewDocument === false);

    return {
      /**
       * TODO
       * cloneDeepWithReference вместо cloneDeep, так как проблемы из-за клонирования shipment,
       * особенно calculateSum, который происходит при клонировании,
       * не придумал как точечно это исправить не проходясь по всему стеку
       * */

      senderCompanySource,
      senderStoreSource,

      delivererStoreSource,

      receiverCompanySource,
      receiverStoreSource,

      responsibleReceiverSource: PersonsService.responsibleSource(isNewDocument),


      localTransportOrder: localTransportOrder,
      localSWPortalTask: Core.utils.isNullOrUndefined(this.swPortalTask) === false ? Core.utils.cloneDeep(this.swPortalTask) : null,
      localReceiversMail: Core.utils.isNullOrUndefined(this.receivers) === false ? Core.utils.cloneDeep(this.receivers) : null,

      isCreateSWPortalTask: Core.utils.isNullOrUndefined(this.swPortalTask) === false,
      isSendToEmail: Core.utils.isNullOrUndefined(this.receivers) === false,
    };
  },

  computed: {
    localTransportOrderType: {
      get(): { id: string; name: string } | undefined {
        return TransportOrder.types.get(this.localTransportOrder.type);
      },
      /** При смене типа ЗТК собирается заново: позиции и участники зависят от типа */
      set(value: { id: string; name: string }): void {
        this.localTransportOrder = TransportOrder.createFromType(value.id);
      },
    },

    assemblies(): Assembly[] {
      return this.localTransportOrder.positions
        .filter((p: any) => p.positionType === 'Assembly')
        .map((p: any) => p.document);
    },

    /**
     * Отправитель скрыт для consolidated, service, single_sender.
     * У internal отправитель показывается: склады отправителя грузятся по sender,
     * без него список складов не загрузится.
     */
    showSender(): boolean {
      // у консолидации много поставщиков, машина объезжает сразу многих, нет одного конкретного
      return this.localTransportOrder.isConsolidated === false
        // Не перевоз товара, смысла в отправителе нет
        && this.localTransportOrder.isService === false
        // Мы в обычной не показывали отправителя
        && this.localTransportOrder.isSingleSender === false;
    },

    /** Склад отправителя скрыт для consolidated, service */
    showSenderStore(): boolean {
      // у консолидации много поставщиков, машина объезжает сразу многих, нет одного конкретного
      return this.localTransportOrder.isConsolidated === false
        // Не перевоз товара, смысла в отправителе нет
        && this.localTransportOrder.isService === false;
    },

    /** Транспорт скрыт для single_sender — обычная ЗТК не подразумевает выбор ТС */
    showVehicle(): boolean {
      return this.localTransportOrder.isSingleSender === false;
    },

    /** Склад перевозчика скрыт для internal, service, single_sender и для Намангана */
    showDelivererStore(): boolean {
      // перевалочный пункт не нужен для внутренних перемещений рохли
      return this.localTransportOrder.isInternal === false
        && this.localTransportOrder.isService === false
        // В обычных ЗТК у нас никогда не было перевалочного пункта
        && this.localTransportOrder.isSingleSender === false
        // У Намангана перевалочного пункта нет
        && this.$core.currentPartner.isNamangan === false;
    },

    /** Стоимость перевозки скрыта для обычной ЗТК */
    showTransportCost(): boolean {
      return this.localTransportOrder.isSingleSender === false;
    },

  },

  watch: {
    /**
     * Своя оценка выбранного водителя правится здесь же и уходит вместе с ЗТК в его поле feedback.
     * Оценки ещё нет (новый водитель или пользователь его не оценивал) — заводим новую,
     * до рендера блока оценки: watch срабатывает раньше обновления шаблона.
     * Водителя выбрали в форме (не первый вызов при открытии) — его обычные транспорт и госномер
     * подставляем в пустые реквизиты ЗТК
     */
    'localTransportOrder.driver': {
      immediate: true,
      handler(driver: Driver | null, oldDriver: Driver | null | undefined): void {
        if (Core.utils.isNullOrUndefined(driver) === false
          && Core.utils.isNullOrUndefined(driver.feedback) === true) {
          driver.feedback = DriverFeedback.fromDriver(driver);
        }
        else {
          // водителя нет либо своя оценка уже есть
        }

        if (oldDriver !== undefined) {
          this.localTransportOrder.fillVehicleFromDriver();
        }
        else {
          // открытие реквизитов — реквизиты ЗТК не трогаем
        }
      },
    },
  },

  methods: {
    addDowntime(): void {
      const downtime = TransportDowntime.fromTransportOrder(this.localTransportOrder.id);

      this.$core.dialogs.TransportDowntimeCard.show({downtime}, {
        [TransportDowntime.Events.Created]: (createdDowntime: TransportDowntime) => {
          this.localTransportOrder.downtimes.push(createdDowntime);

          this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder)
        },
      });
    },

    editDowntime(downtime: TransportDowntime, index: number): void {
      this.$core.dialogs.TransportDowntimeCard.show({downtime}, {
        [TransportDowntime.Events.Updated]: (updatedDowntime: TransportDowntime) => {
          this.localTransportOrder.downtimes[index] = updatedDowntime;

          this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder)
        },
      });
    },

    /**
     * Пункт меню простоя выполнен. Простои сохраняются на бэк сразу, мимо ЗТК,
     * поэтому список просто перечитываем, а не правим локально по индексу
     */
    async reloadDowntimes(): Promise<void> {
      this.localTransportOrder.downtimes = await TransportDowntimesService.getList({
        transportOrder: { id: this.localTransportOrder.id },
      });

      this.$emit(TransportDowntime.Events.Updated, this.localTransportOrder);
    },

    async save(): Promise<void> {
      // Пустую оценку (звёзды не выбраны) заводит watch водителя — под блок оценки.
      // На бэк её не отправляем: оценка там обязательна, и пустая роняет сохранение ЗТК
      if (Core.utils.isNullOrUndefined(this.localTransportOrder.driver) === false
        && Core.utils.isNullOrUndefined(this.localTransportOrder.driver.feedback?.rate) === true) {
        this.localTransportOrder.driver.feedback = null;
      }
      else {
        // водителя нет либо оценка выбрана
      }

      this.$emit('save', {
        transportOrder: this.localTransportOrder,
        SWPortalTask: this.localSWPortalTask,
        receivers: this.localReceiversMail,
      });
      this.$core.dialogs.TransportOrderRequisitesDialog.resolve();
    },

    updateReceivers(receivers: any[]): void {
      this.localReceiversMail = receivers;
    },

    onToggleSendEmail(value: boolean): void {
      if (value === true) {
        this.localReceiversMail = SWPortalTasksService.getReceivers();
      } else {
        this.localReceiversMail = null;
      }
    },

    setPickupDatePlanned(value: any): void {
      this.localTransportOrder.pickupDatePlanned = value;

      if (Core.utils.isNullOrUndefined(this.localSWPortalTask) === false) {
        this.localSWPortalTask.updateTitle();
      }
    },

    onTogglePortalTask(value: boolean): void {
      if (value === true) {
        this.localSWPortalTask = SWPortalTask.fromTransportOrder(this.localTransportOrder);
      } else {
        this.localSWPortalTask = null;
      }
    },

    showDelivererCreateDialog(): void {
      this.$core.dialogs.DelivererCreatePopup.show({
        target:   this.$refs.delivererSelect.$el,
        onCreate: (deliverer: Partner) => {
          this.localTransportOrder.deliverer = deliverer;
        },
      });
    },

    openSWPortalTaskDialog(): void {
      this.$core.dialogs.SWPortalTaskCreateDialog.show(
        { transportOrder: this.localTransportOrder },
        { [SWPortalTask.Events.Created]: () => this.$emit('save') },
      );
    },

  },
});
</script>
